import { Component, OnInit, ViewChild} from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { BaseChartDirective } from 'ng2-charts';
import * as firebase from 'firebase';
import { CdkDragEnd } from "@angular/cdk/drag-drop";
import {GraphService} from '../../services/graph.service'
import * as xml2js from 'xml2js';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.scss']
})
export class BarComponent implements OnInit {

  constructor(private graphService : GraphService) { }
  
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  barChartOptions: ChartOptions = {
    responsive: true,
  };
  barChartLabels: Label[] = ['Apple', 'Banana', 'Kiwifruit', 'Blueberry', 'Orange', 'Grapes'];
  barChartType = 'bar';
  barChartLegend = true;
  barChartPlugins = [];

  barChartData: ChartDataSets[] = [
    { data: [45, 37, 60, 70, 46, 33], label: 'Best Fruits' }
  ];

  setting = false
  draggable = false
  height:any
  width:any 
  top: any
  left:any
  myValue:number
  user : any
  ref:any
  isSet = false
  isActif:boolean

  initialPosition :any 
  position = { ...this.initialPosition };
  offset = { x: 0, y: 0 };
  newGraph

  ngOnInit(): void {
    var parseString = require('xml2js').parseString;
    var xml = "<root>Hello xml2js!</root>"
    parseString(xml, function (err, result) {
    console.dir(result);
});

    this.isSet = false
    this.user = firebase.auth().currentUser.uid
    this.ref = firebase.database().ref('configCharts/bar/' + this.user)

    this.ref.orderByKey().once("value", (snapshot) => {
      if(snapshot.val() != null){
        this.initialPosition = { x: snapshot.val().left, y: snapshot.val().top }
        this.height = snapshot.val().height
        this.width = snapshot.val().width
        this.top = snapshot.val().top
        this.left = snapshot.val().left
        this.isActif = snapshot.val().actif
        this.barChartType = snapshot.val().type
        this.newGraph = false
      }else{
        this.newGraph = true
        this.initialPosition = { x: 100, y: 100}
        this.height = 200
        this.width = 400
        this.top = 100
        this.left = 100
      }
     
    }).then(()=>{
      this.isSet = true
    })
  }

  onInputChange(value){

    this.myValue = value;
    this.chart.chart.canvas.parentElement.style.height = value+'px'
    this.chart.chart.canvas.parentElement.style.width = 2*value+'px'
    this.chart.chart.resize()

    
  }


  changeFrequency(){
      
  }

  showSetting(){
    if(this.setting == true){
      this.setting = false
      this.draggable = false

     if(this.newGraph == false){
      firebase.database().ref('configCharts/bar/' + this.user).update({
        width : this.chart.chart.canvas.parentElement.style.width.replace('px',''),
        height : this.chart.chart.canvas.parentElement.style.height.replace('px',''),
        top : this.top + this.offset.y,
        left : this.left + this.offset.x
       })
     }else{
      firebase.database().ref('configCharts/bar/' + this.user).set({
        width : this.chart.chart.canvas.parentElement.style.width.replace('px',''),
        height : this.chart.chart.canvas.parentElement.style.height.replace('px',''),
        top : this.top + this.offset.y,
        left : this.left + this.offset.x
       })
     }
      
    }else{
      this.setting = true
    }
  }


  dragEnd(event: CdkDragEnd) {

    this.offset = { ...(<any>event.source._dragRef)._passiveTransform };
    this.position.x = this.initialPosition.x + this.offset.x;
    this.position.y = this.initialPosition.y + this.offset.y;

  }

  setInactive(comp){
    this.graphService.setInactive(comp, 'tt')
  }

  changeStyle(style:string){
    this.graphService.changeType('bar',style);
    this.barChartType = style
  }

}
